import * as React from "react";
const SvgFiRrPhysics = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-physics_svg__a)">
      <path d="M22.563 1.437C20.189-.937 16.643-.358 12 3.137 7.357-.358 3.813-.938 1.437 1.437S-.358 7.357 3.137 12c-3.495 4.643-4.075 8.188-1.7 10.563A4.7 4.7 0 0 0 4.879 24c1.97 0 4.35-1.052 7.12-3.136C14.77 22.948 17.15 24 19.122 24a4.7 4.7 0 0 0 3.442-1.437c2.375-2.375 1.8-5.919-1.7-10.563 3.495-4.644 4.075-8.188 1.7-10.563m-3.478.591a2.8 2.8 0 0 1 2.067.82c1.746 1.746.456 4.712-1.588 7.538a52 52 0 0 0-2.858-3.092 51 51 0 0 0-3.094-2.86c1.898-1.373 3.86-2.406 5.473-2.406M18.31 12a50 50 0 0 1-3.016 3.3c-.934.94-2.075 2-3.295 3.011a50 50 0 0 1-3.295-3.01A48 48 0 0 1 5.689 12a49 49 0 0 1 3.016-3.296A49 49 0 0 1 12 5.688 50 50 0 0 1 18.31 12M2.848 2.848a2.8 2.8 0 0 1 2.067-.82c1.613 0 3.575 1.033 5.473 2.406a52 52 0 0 0-3.094 2.86 50 50 0 0 0-2.86 3.092C2.393 7.56 1.1 4.594 2.849 2.848m0 18.3c-1.746-1.746-.456-4.713 1.587-7.538a52 52 0 0 0 2.859 3.092 51 51 0 0 0 3.089 2.861c-2.825 2.046-5.791 3.337-7.535 1.59zm18.3 0c-1.745 1.744-4.71.457-7.535-1.585a52 52 0 0 0 3.089-2.86 50 50 0 0 0 2.858-3.093c2.048 2.83 3.34 5.796 1.592 7.542z" />
      <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    </g>
    <defs>
      <clipPath id="fi-rr-physics_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhysics;
